import React, { useEffect, useRef, useState } from 'react';
import { strings } from '../constants/strings';
import { colors } from '../constants/colors';
import { Award, Shield, Zap } from 'lucide-react';

const statIcons = [Award, Shield, Zap];

const Portfolio = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="portfolio" className="section-padding" ref={sectionRef} style={{ background: colors.backgroundAlt }}>
      <div className="container">
        <div className={`section-header ${isVisible ? 'fade-in-up' : ''}`}>
          <h2 className="section-title">{strings.portfolio.title}</h2>
        </div>
        
        <div className="portfolio-stats">
          {strings.portfolio.stats.map((stat, index) => {
            const Icon = statIcons[index];
            return (
              <div 
                key={index} 
                className={`stat-card ${isVisible ? 'flip-in' : ''}`}
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <Icon size={32} style={{ color: colors.accent }} />
                <p>{stat}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
